import React from 'react'
import error404 from '../../images/error_404.png';

export default function NotFound() {
    return (

        <div className="mt-4 row justify-content-center align-items-center " >
            <img alt="" className="row mt-4" style={{ width: '40%' }} src={error404} />
            {/* <h4 className="row">Pagina no encontrada</h4> */}
        </div>
    );
}